<template>
    <div id="examResult" v-show="show">
      <exam-header ></exam-header>
      <el-row>
        <!-- <el-col :span="12" >
          <div class="item" style="padding-left:40px">{{psnName}}({{pId}})</div>
        </el-col> -->

      <el-col :span="12"  :offset="6">
        <div class="exam-result" >

          <div class="result-img">

                <img  v-if="standard!=1" src="../../assets/exam/result_fail.png"/>
                <img  v-else src="../../assets/exam/result_success.png"/>
          </div>
            <div class="item">
              <span v-if="standard==1" class="result-show font-green">恭喜您考试通过</span>
              <span v-else class="result-show font-red">本次考试不及格，请继续努力</span>

          </div>
          <div class="item">
            {{psnName}}({{pId}})<br/>
              考试结果为：{{score}}分

          </div>
          <span v-if="standard!=1&& type!='INTERNET'" >下次机会请于{{reTime}}再来尝试</span>
          <div class="item">
             <el-button type="primary" v-if="show_continue" @click="ToContinue"   class="btn">
               继续考试
            </el-button>
              <el-button type="primary" v-if="back || induct" @click="ToContinue"   class="btn">
               返回
            </el-button>
              <!-- <el-button type="primary" v-if="induct" @click="selfInduct"   class="btn">
               自助入司
            </el-button> -->
          </div>
         </div>
      </el-col>
    </el-row>
    <el-dialog
    title="温馨提示"
    :visible.sync="showDialog"
    width="30%"
    center>
    <span>PC端暂不支持“自助入司”，请前往APP或PAD进行入司</span>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="showDialog = false">确 定</el-button>
    </span>
</el-dialog>
    </div>

</template>
<script>
import api from '@/modules/api.js'
import session from '@/components/cache'
import examHeader from '@/layout/ExamHeader.vue'
import moment from 'moment'
import url from '@/modules/url'
import {showFullScreenLoading, tryHideFullScreenLoading} from '@/components/utils/loading.js'
export default {
  components: {examHeader},
  data () {
    return {
      req: {
        manageCom: '',
        userId: '',
        type: ''
      },
      score: '',
      show_continue: false,
      state: '',
      induct: false,
      reTime: '',
      back: false,
      showDialog: false,
      show: false,
      type: '',
      standard: null,
      pId:'',
      psnName:''
    }
  },
  methods: {
    init(){
      let that =this
      api.post(url.getPuserInfo, {}, function (res) {
        console.log(123,res)
        that.psnName = res.data.psnName
        that.pId = res.data.pId
      })
    },
    ToContinue () {
      if(this.induct){
        window.sessionStorage.removeItem('sidebar_active');
        this.delCookie('jtl')
        this.homePage = window.location.href.split('/')[0] + '//' + window.location.href.split('/')[1] + window.location.href.split('/')[2]
        // window.location.href = 'https://testsso.ihasl.com/SSO2/SSO-JTL2.html?service=' + encodeURIComponent('https://testsso.ihasl.com/HASLSSO2/logout?service=' + encodeURIComponent(this.homePage + '/pages/salessupport/pc/index.html#/'))
        window.location.href = this.$logOutFront + encodeURIComponent(this.$logOutBack + encodeURIComponent(this.homePage + this.$address))
      }else{
        this.$router.push({name: 'examChooseTest'})
      }

    },
    selfInduct () {
      this.$router.push({name: 'baseInfo'})
    },
    logOut () {
      window.sessionStorage.removeItem('sidebar_active');
      this.delCookie('jtl')
      this.homePage = window.location.href.split('/')[0] + '//' + window.location.href.split('/')[1] + window.location.href.split('/')[2]
      // window.location.href = 'https://testsso.ihasl.com/SSO2/SSO-JTL2.html?service=' + encodeURIComponent('https://testsso.ihasl.com/HASLSSO2/logout?service=' + encodeURIComponent(this.homePage + '/pages/salessupport/pc/index.html#/'))
      window.location.href = this.$logOutFront + encodeURIComponent(this.$logOutBack + encodeURIComponent(this.homePage + this.$address))
    },
    getCookie (key) {
      var arr, reg = RegExp('(^| )' + key + '=([^;]+)(;|$)')
      if (arr = document.cookie.match(reg)) // ["username=liuwei;", "", "liuwei", ";"]
      { return decodeURIComponent(arr[2]) } else { return null }
    },
    delCookie (key) {
      var date = new Date()
      date.setTime(date.getTime() - 1)
      var delValue = this.getCookie(key)
      if (delValue) {
        document.cookie = key + '=' + delValue + ';expires=' + date.toGMTString()
      }
    },
  },

  mounted () {
    showFullScreenLoading()
    // 获取路由参数
    this.req.manageCom = session.session_get('manageCom')
    this.req.type = this.$route.query.type
    this.type = this.$route.query.type
    //this.standard= session.session_get('passingGrade')//考试通过成绩
    this.req.userId = session.session_get('businessNo')
    this.init()
    let that = this
    // 查看考试结果
    api.getExamResult(this.req, function (res) {
      if (res.result.isSuccess === true) {
        that.score = res.data.score
        that.standard = res.data.examResult
        if (res.data.reTime != null && res.data.reTime !== '') {
          that.reTime = res.data.reTime
          that.reTime = moment(that.reTime).format('YYYY-MM-DD HH:mm')
        }
      } else {
        that.$message.error(res.result.error)
      }
    })

    let req = {
      businessNo: this.req.userId,
      agentId: ''
    }
    // 查看入司状态
    api.getExamState(req, function (res) {
      if (res.result.isSuccess === true) {
        let state = res.data.state
        that.state = state
        if (state === 1) {
          console.log('未完成全部考试')
          that.show_continue = true
        }
        if (state === 2) {
          console.log('考试成功')
          that.induct = true
          that.showDialog = true
        }
        if (state === 3) {
          console.log('考试失败')
          that.back = true
        }
        tryHideFullScreenLoading()
        that.show = true
      } else {
        tryHideFullScreenLoading()
        that.$message.error(res.result.error)
      }
    })
  }
}
</script>
<style lang="scss" scoped>
[v-cloak]{
  display: none;
}
.exam-result{
  // padding: 20px 50px 50px 50px;
  // border-radius: 3%;
  max-width: 400px;
  margin: 0 auto;
  margin-top: 50px;
  text-align: center
}
// .result-img{
//     // height: 150px;
// }
.result-img img{
  // height:100%
  width: 45%;
}
.item{
  margin-top: 25px;
  margin-bottom: 5px;
}

.btn{
  background-color:#C2A66E;
  border-color:#C2A66E;
  width: 50%;
}
.result-show{
  font-size: 20px;
}
.font-green{
  color: #18C29C;
}
.font-red{
  color: #FF6969;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examResult.vue